module.exports = __webpack_public_path__ + "img/pic3.135aa9b2.png";